import styled from 'styled-components';

export const SInstanceChangeContainer = styled.div`
  max-width: 300px;
  border-radius: 5px;
  overflow: hidden;
  box-shadow: 0 3px 15px rgb(0 0 0 / 0.2);
  position: fixed;
`;

export const SInstanceChangeTopBar = styled.div`
  background-color: ${({ theme }) => theme.colors.primaryText};
  padding-top: 15px;
  padding-bottom: 15px;
  padding-left: 20px;
  text-align: left !important;
`;

export const SInstanceListbox = styled.div`
  max-height: 100px;
  overflow-y: auto;
`;

export interface IInstanceLsitboxItem {
  isSelected: boolean;
}

export const SInstanceListboxItem = styled.div<IInstanceLsitboxItem>`
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 15px;
  padding-bottom: 15px;
  cursor: pointer;
  background-color: ${({ theme, isSelected }) =>
    isSelected ? theme.colors.primaryBackground : theme.colors.secondaryBackground};
  text-align: left !important;
  display: flex;
  justify-content: space-between;
`;
